import React from 'react';
import ServiceList from '../ServiceList/ServiceList';
import Sidebar from '../Sidebar/Sidebar';

const Dashboard = () => {
    
    return (
        <section>
        
            <ServiceList></ServiceList>
        </section>
    );
};

export default Dashboard;